import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ProveedoresService } from 'src/app/services/proveedores.service';

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.scss']
})
export class ProveedoresComponent implements OnInit {
  respuestaGet:any;
  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  formulario;
  formularioEdit;
  filtro;

  data:any;
  datos:any;

  proveedores:any;
  proveedorId:any;

  estados:any;
  municipios:any;
  municipiosE:any;

  municipioSelected:any;
  estadoSelected:any;


  constructor(private _proveedor:ProveedoresService,
    private modalService:NgbModal, private iziToast:Ng2IzitoastService,) { }

  ngOnInit(): void {
    this.getProveedores();
    this.getEstados();

    this.formulario = {
      'estado': '',
      'municipio': '',
      'telefono':'',
      'contacto': '',
      'email': '',
      'celular': '',
      'cp': '',
      'colonia': '',
      'direccion': '',
      'rfc': '',
      'nombre': '',
    }

    this.formularioEdit = {
      'estado': '',
      'municipio': '',
      'telefono':'',
      'contacto': '',
      'email': '',
      'celular': '',
      'cp': '',
      'colonia': '',
      'direccion': '',
      'rfc': '',
      'nombre': '',
    }
  }

  getProveedores(){
    this._proveedor.getProveedores().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.proveedores = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getEstados(){
    this._proveedor.getEstados().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.estados = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getMunicipios(){
    this.data = {
      'estado':this.formulario.estado,
    }
    this._proveedor.getMunicipios(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.municipios = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getProveedoresFiltrados(){
    this.data = {
      'activo': 1,
    }
    this._proveedor.getProveedoresFiltrados(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.proveedores = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  agregar(){
    this.data = {
      'nombre_razon_social': this.formulario.nombre,
      'rfc': this.formulario.rfc,
      'direccion': this.formulario.direccion,
      'colonia': this.formulario.colonia,
      'cp': this.formulario.cp,
      'municipio': this.formulario.municipio,
      'contacto': this.formulario.contacto,
      'telefono': this.formulario.telefono,
      'celular': this.formulario.celular,
      'email': this.formulario.email,
    }

    this._proveedor.agregarProveedor(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el proveedor correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getProveedoresFiltrados();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editar(proveedor:any){
    this.data = {
      'proveedor':proveedor,
    }
    this._proveedor.editarProveedor(this.data).subscribe(
      data => {
        this.respuestaEditar = data;
        if(this.respuestaEditar.success){
          this.datos = this.respuestaEditar.content;
          this.municipiosE = this.respuestaEditar.municipios;
          this.estadoSelected = this.respuestaEditar.estadoSelected;
          this.municipioSelected = this.respuestaEditar.municipioSelected;
          this.formularioEdit.nombre = this.datos.nombre_razon_social;
          this.formularioEdit.rfc = this.datos.rfc;
          this.formularioEdit.direccion = this.datos.direccion;
          this.formularioEdit.colonia = this.datos.colonia;
          this.formularioEdit.cp = this.datos.cp;
          this.formularioEdit.municipio = this.municipioSelected;
          this.formularioEdit.estado = this.estadoSelected;
          this.formularioEdit.telefono = this.datos.telefono;
          this.formularioEdit.contacto = this.datos.contacto;
          this.formularioEdit.celular = this.datos.celular;
          this.formularioEdit.email = this.datos.email;
          this.proveedorId = proveedor;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  actualizar(proveedor:any){
    this.data = {
      'nombre_razon_social': this.formularioEdit.nombre,
      'rfc': this.formularioEdit.rfc,
      'direccion': this.formularioEdit.direccion,
      'colonia': this.formularioEdit.colonia,
      'cp': this.formularioEdit.cp,
      'municipio': this.formularioEdit.municipio,
      'contacto': this.formularioEdit.contacto,
      'telefono': this.formularioEdit.telefono,
      'celular': this.formularioEdit.celular,
      'email': this.formularioEdit.email,
      'proveedor': proveedor,
    }

    this._proveedor.updateProveedor(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha editado el proveedor correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getProveedoresFiltrados();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal:any) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }


}
